import * as PIXI from 'pixi.js';
import { scaleFactor, tweenFade, tweenFadeAppear } from '../utility';
import { containers, gameAssets } from '../gameUI';
import { playPopUpClose } from '../soundManager';
import { gameData } from '../data';
import { disableButtons } from '../gameLogic';

export const PopUpType = ["NETWORK ERROR", "INSUFFICIENT BALANCE", "MANUAL"]

export class popUp {

    popUpContainer = null;
    popUpGraphic = null;
    text = null;
    closeButton = null
    dimmer = null
    chicken = null


    constructor(x, y, width = 1000, height = 600, arch = 30) {

        this.popUpContainer = new PIXI.Container();
        this.popUpContainer.x = x;
        this.popUpContainer.y = y;
        this.popUpContainer.initialX = x;
        this.popUpContainer.initialY = y + 100;
        this.popUpContainer.finalX = x;
        this.popUpContainer.finalY = y;
        this.popUpContainer.visible = false;
        this.popUpContainer.zIndex = 99
        this.dimmer = new PIXI.Sprite(PIXI.Assets.get('dimmer'))
        this.dimmer.anchor.set(0.5)
        // this.dimmer.y = -1500
        this.dimmer.scale.set(4)
        // this.popUpContainer.addChild(this.dimmer)
        // containers.bgContainer.addChild(this.popUpContainer);
        // this.popUpGraphic = new PIXI.Graphics();
        // this.popUpGraphic.lineStyle(20, 0xDEB182, 1);
        // this.popUpGraphic.beginFill(0x301813, 1);
        // this.popUpGraphic.drawRoundedRect(-width / 2, -height / 2, width, height, arch);
        // this.popUpGraphic.endFill();
        this.popUpGraphic = new PIXI.Sprite(PIXI.Assets.get('main_board'))
        this.popUpGraphic.anchor.set(0.5)
        this.popUpGraphic.scale.set(0.4)
        
        
        this.popUpGraphic.x = 240;
        this.popUpGraphic.y = -650;
        
        this.popUpContainer.on("pointerdown", () => { this.closePopUp() })
        this.popUpContainer.addChild(this.popUpGraphic);
        this.createText();
        //    this.popUpContainer.visible = false;
        this.closeButton = new PIXI.Sprite(PIXI.Assets.get('close_b_normal'))
        this.closeButton.anchor.set(0.5)
        this.closeButton.scale.set(0.5)
        this.closeButton.x = this.popUpGraphic.width * 0.25 - this.closeButton.width * 0.5
        this.closeButton.y = -this.popUpGraphic.height * 0.25 + this.closeButton.height * 0.5
        this.popUpGraphic.addChild(this.closeButton)

        this.chicken = new PIXI.Sprite(PIXI.Assets.get('chicken_cry'))
        this.chicken.scale.set(1.5)
        this.chicken.anchor.set(0.5)
        this.chicken.y = -150
        this.popUpContainer.addChild(this.chicken)

    }

    createText() {
        this.text = new PIXI.BitmapText("INSUFFICIENT\nBALANCE", {
            fontName: 'font-export',
            fontSize: 15,
            align: 'center',
            letterSpacing: -10, //-72,
        });
        this.text.anchor.set(0.5)
        this.text.x = 250
        this.text.y = -650
        this.popUpContainer.addChild(this.text);
    }

    popUp(popUpText = "TEXT HERE") {
        tweenFadeAppear(this.popUpContainer, true)
        this.text.text = popUpText;
        this.popUpContainer.interactive = true;
    }

    closePopUp() {
        tweenFadeAppear(this.popUpContainer, false)
        this.popUpContainer.interactive = false;
    }


}

export const setupPopup = () => {
    if(!gameAssets.popUpBase){
        gameAssets.popUpBase = new PIXI.Sprite(PIXI.Assets.get('main_board'))
    } 
    containers.bgContainer.addChild(gameAssets.popUpBase)
    gameAssets.popUpBase.visible = false
    gameAssets.popUpBase.alpha = 1
    gameAssets.popUpBase.zIndex = 5002
    gameAssets.popUpBase.anchor.set(0.5)

    const width = gameAssets.popUpBase.width
    const height = gameAssets.popUpBase.height
    gameAssets.popUpBase.resize = (w, h) => {
        const expandFactor = 0.8
        const scale = scaleFactor(gameAssets.gameScreen.width, width)
        gameAssets.popUpBase.x = w * 0.5
        gameAssets.popUpBase.y = h * 0.5
        gameAssets.popUpBase.width = width * scale * expandFactor
        gameAssets.popUpBase.height = height * scale * expandFactor
    }  

    if(!gameAssets.popUpClose) gameAssets.popUpClose = new PIXI.Sprite(PIXI.Assets.get('close_b_normal'))
    gameAssets.popUpClose.anchor.set(0.5)
    gameAssets.popUpBase.addChild(gameAssets.popUpClose)
    gameAssets.popUpClose.x = 650
    gameAssets.popUpClose.y = -400
    gameAssets.popUpClose.interactive = false
    gameAssets.popUpClose.buttonMode = false
    gameAssets.popUpClose.cursor = 'pointer'
    gameAssets.popUpClose.on('pointerover', ()=> {gameAssets.popUpClose.texture = PIXI.Assets.get('close_b_selected')})
    gameAssets.popUpClose.on('pointerout', ()=> {gameAssets.popUpClose.texture = PIXI.Assets.get('close_b_normal')})
    gameAssets.popUpClose.on('pointerdown', (event)=>{
        if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
            hidePopup()
        }
    })

    if(!gameAssets.popUpText) gameAssets.popUpText = new PIXI.BitmapText("Unexpected\nError", {
        fontName: 'font-export',
        fontSize: 30,
        align: 'center',
        letterSpacing: 0, //-72,
    });
    gameAssets.popUpText.anchor.set(0.5)
    gameAssets.popUpBase.addChild(gameAssets.popUpText)

}

export const hidePopup = () => {
    // gameAssets.popUpClose.texture = PIXI.Assets.get('close_b_down')
    playPopUpClose(true);
    gameData.isPopupOpen = false;
    tweenFade(gameAssets.popUpBase, false, 0.3)
    gameAssets.popUpBase.visible = false
    tweenFade(gameAssets.dimmer, false, 0.3)
    gameAssets.dimmer.visible = false
    gameAssets.popUpClose.interactiveChildren = false
    disableButtons(false)
}

export const popUpShow = (message) => {
    gameData.isPopupOpen = true;
    gameAssets.popUpClose.interactive = true
    gameAssets.popUpClose.buttonMode = true
    tweenFade(gameAssets.dimmer, true)
    gameAssets.dimmer.visible = true;
    tweenFade(gameAssets.popUpBase, true)
    gameAssets.popUpText.text = message
    disableButtons(true)
}